import { Component, Input } from '@angular/core';
import { categories, recentOrders } from '../../../data/dashboard/e-commerce';
import { Categories, RecentOrders } from '../../../interface/dashboard/e-commerce';

@Component({
	selector: 'orders-by-categories',
	templateUrl: './orders-by-categories.component.html',
	styleUrls: ['./orders-by-categories.component.scss']
})
export class OrdersByCategoriesComponent {
	@Input() categories = categories;
	@Input() recentOrders = recentOrders;
	public activeCategory: string = 'furniture';
	public filteredOrders: RecentOrders[];

	ngOnInit() {
		if (this.activeCategory) {
			this.filteredOrders = this.recentOrders.filter(order => {
				return order.category === this.activeCategory;
			});
		}
	}

	changeCategory(category: Categories) {
		this.activeCategory = category.value;

		this.filteredOrders = this.recentOrders.filter(order => {
			return order.category === this.activeCategory;
		});
	}
	trackByCategory(index: number, category: any): string {
		return category?.value;
	}

	trackByOrder(index: number, order: any): string {
		return order?.product_id;
	}
}
